import React, { useState } from 'react';

import { useTypedDispatch, useTypedSelector } from '@/store/store';
import {
  deleteCarGearbox,
  getSelectedFilters,
  getStockFilterParams,
  setCarGearbox,
  setCarGearboxAll,
  setPage,
} from '@/store/reducers/cars-stock';
import { getGearboxOptions } from '@/modules/CarsStock/components/common.helpers';
import StockMobileSidePanel from '@/components/StockMobileSidePanel';
import {
  FilterButton,
  FilterButtonWrapper,
  MobileFilterItemWrapper,
} from '@/modules/CarsStock/components/common.styles';
import StockFilterMultiSelectParts from '@/components/StockFilterMultiSelectParts';
import {
  StockFilterMultiSelectPartsOptionType,
  StockFilterMultiSelectPartsSelectedOptionType,
} from '@/components/StockFilterMultiSelectParts/types';

function GearboxFilter() {
  const dispatch = useTypedDispatch();
  const stockFilterParams = useTypedSelector(getStockFilterParams);
  const selectedGearboxes =
    useTypedSelector(getSelectedFilters).selectedParams.selectedGearbox;
  const [isOpened, setOpened] = useState(false);

  const gearboxOptions = getGearboxOptions(stockFilterParams);

  const handleSidePanelOpen = () => {
    setOpened(true);
  };

  const handleSidePanelClose = () => {
    setOpened(false);
  };

  const handleChangeGearbox = (
    gearbox: StockFilterMultiSelectPartsSelectedOptionType
  ) => {
    dispatch(setCarGearbox(gearbox));
    dispatch(setPage(1));
  };

  const handleChangeGearboxAll = (
    gearbox: StockFilterMultiSelectPartsOptionType
  ) => {
    dispatch(setCarGearboxAll(gearbox));
    dispatch(setPage(1));
  };

  const handleClearGearbox = () => {
    dispatch(deleteCarGearbox());
    dispatch(setPage(1));
  };

  return (
    <StockMobileSidePanel
      title="Коробка передач"
      zIndex={10001}
      isInnerSidePanel
      isOpened={isOpened}
      onOpen={handleSidePanelOpen}
      onClose={handleSidePanelClose}
    >
      <MobileFilterItemWrapper>
        <StockFilterMultiSelectParts
          options={gearboxOptions}
          selectedOptions={selectedGearboxes}
          onChange={handleChangeGearbox}
          onChangeAll={handleChangeGearboxAll}
          onClear={handleClearGearbox}
        />
      </MobileFilterItemWrapper>

      <FilterButtonWrapper>
        <FilterButton onClick={handleSidePanelClose}>Применить</FilterButton>
      </FilterButtonWrapper>
    </StockMobileSidePanel>
  );
}

export default GearboxFilter;
